import React from 'react';
import PropTypes from 'prop-types';

import CurrentPage, { getCurrentPageProps } from '@components/pages/currentPage/currentPage';
import Exhibition, { getExhibitionProps } from '@components/pages/exhibition/exhibition';
import LandingPage from '@components/pages/landing/landing';
import Time, { getTimeProps } from '@components/pages/time/time';
import ArchivePage, { getArchiveProps } from 'components/pages/archive/archive';

import { wrapper } from '@redux/store';
import { appSetPageData } from '@redux/actions/app';

const Page = props => {
  const { data, PAGE_TYPE, type } = props;

  if (PAGE_TYPE === 'TIME') {
    return (
      <Time
        data={{
          data
        }}
      />
    );
  }

  if (PAGE_TYPE === 'EXHIBITION') {
    return <Exhibition data={props} />;
  }

  if (PAGE_TYPE === 'UNIVERSAL' && type === 'landingpageSimple') {
    return <LandingPage {...props} />;
  }

  if (PAGE_TYPE === 'ARCHIVE') {
    return <ArchivePage data={props} />;
  }

  return <CurrentPage data={props} />;
};

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ locale, params: { uri }, query, resolvedUrl }) => {
      let props = null;

      if (['exhibition', 'ausstellung'].includes(uri)) {
        props = await getExhibitionProps({ locale, uri });
      } else if (
        ['was-ist', 'what-is', 'was-war', 'what-was', 'was-kommt', 'what-will-be'].includes(uri)
      ) {
        props = await getTimeProps({ query, locale, uri });
      } else if (['archive', 'archiv'].includes(uri)) {
        props = await getArchiveProps({ locale, uri });
      } else {
        props = await getCurrentPageProps({
          locale,
          resolvedUrl
        });
      }

      await store.dispatch(appSetPageData(props));

      return {
        props,
        notFound: !props?.PAGE_TYPE || !!props?.error
      };
    }
);

Page.propTypes = {
  data: PropTypes.shape().isRequired,
  PAGE_TYPE: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default Page;
